module.exports = __webpack_public_path__ + "static/media/veikals_paka_3.75bb19f5.png";